import propTypes from 'prop-types';
import * as S from './styles';

const InviteInfoRow = ({ icon, label, children }) => (
  <S.Row>
    <S.IconWrapper>{icon}</S.IconWrapper>
    <S.Content>
      <S.Label>{label}</S.Label>
      <S.Value>{children}</S.Value>
    </S.Content>
  </S.Row>
);

InviteInfoRow.propTypes = {
  icon: propTypes.node.isRequired,
  label: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
};

export default InviteInfoRow;
